// MainContent renders the full page layout: sidebar, navbar, routes, footer.
// It uses AuthContext to access user and layout information.

import React, { useRef, useEffect, useState, useContext } from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import { makeStyles } from "@material-ui/core/styles";
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";
import { Switch, Redirect } from "react-router-dom";
import { ToastContainer } from "react-toastify";

import AuthContext from "../../connections/auth/AuthProvider";
import Sidebar from "../../components/Sidebar/Sidebar";
import MainNavbar from "../../components/Navbars/MainNavbar";
import Footer from "../../components/Footer/Footer";
import { getActiveRoute, getRoutes } from "./routesSwitch";
import routes from "../../routes";
import styles from "assets/jss/material-dashboard-pro-react/layouts/adminStyle.js";

let ps;

export default function MainContent({
  setChangePasswordModalOpen,
  setChangeProjectModalOpen,
}) {
  const { userDetails } = useContext(AuthContext);

  const useStyles = makeStyles((theme) => ({
    ...styles(theme, userDetails.implementation_color),
  }));
  const classes = useStyles();

  const [mobileOpen, setMobileOpen] = useState(false);
  const [miniActive, setMiniActive] = useState(true);

  const mainPanel = useRef(null);

  const mainPanelClasses =
    classes.mainPanel +
    " " +
    cx({
      [classes.mainPanelSidebarMini]: miniActive,
      [classes.mainPanelWithPerfectScrollbar]:
        navigator.platform.indexOf("Win") > -1,
    });

  useEffect(() => {
    if (navigator.platform.indexOf("Win") > -1 && mainPanel.current) {
      ps = new PerfectScrollbar(mainPanel.current, {
        suppressScrollX: true,
        suppressScrollY: false,
      });
      document.body.style.overflow = "hidden";
    }

    const resizeFunction = () => {
      if (window.innerWidth >= 960) {
        setMobileOpen(false);
      }
    };

    window.addEventListener("resize", resizeFunction);

    return () => {
      if (navigator.platform.indexOf("Win") > -1 && ps) {
        ps.destroy();
      }
      window.removeEventListener("resize", resizeFunction);
    };
  }, []);

  return (
    <div className={classes.wrapper}>
      <Sidebar
        routes={routes}
        logoText={userDetails.implementation_name}
        logo={userDetails.implementation_logo_white}
        handleDrawerToggle={() => setMobileOpen(!mobileOpen)}
        open={mobileOpen}
        color={"client"}
        miniActive={miniActive}
        setChangePasswordModalOpen={setChangePasswordModalOpen}
        setChangeProjectModalOpen={setChangeProjectModalOpen}
      />
      <div className={mainPanelClasses} ref={mainPanel}>
        <MainNavbar
          sidebarMinimize={() => setMiniActive(!miniActive)}
          miniActive={miniActive}
          brandText={getActiveRoute(routes)}
          handleDrawerToggle={() => setMobileOpen(!mobileOpen)}
        />
        <div className={classes.content}>
          <ToastContainer />
          <div className={classes.container}>
            <Switch>
              {getRoutes(routes, userDetails)}
              <Redirect from="/main" to="/main/no-permission" />
            </Switch>
          </div>
        </div>
        <Footer fluid />
      </div>
    </div>
  );
}

MainContent.propTypes = {
  setChangePasswordModalOpen: PropTypes.func.isRequired,
  setChangeProjectModalOpen: PropTypes.func.isRequired,
};
